import React, { useEffect, useState } from 'react';
import { BsArrowLeft, BsArrowRight } from 'react-icons/bs';

import Class from '../Class';

import { Container, Pagination, NumberOfPage } from './styles';

const ListClass = ({
  lessons,
  pathname,
  setShowLoadModal,
  setShowNoAccessModal,
  checkIfUserHasAnActivePlan,
}) => {
  function renderLessons() {
    return lessons.map((item) => (
      <Class
        item={item}
        pathname={pathname}
        setShowLoadModal={setShowLoadModal}
        setShowNoAccessModal={setShowNoAccessModal}
        checkIfUserHasAnActivePlan={checkIfUserHasAnActivePlan}
      />
    ));
  }

  return <Container>{renderLessons()}</Container>;
};

export default ListClass;
